import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './api'

const MINUTO = 60 * 1000

/** Quantas vezes vale a pena insistir antes de mostrar o estado de erro. */
const MAX_TENTATIVAS = 2

/**
 * Repetir só faz sentido em falha de rede ou erro do servidor. 4xx é decisão do
 * servidor sobre o pedido — insistir só atrasa a mensagem de erro para o
 * usuário e multiplica requisição inútil.
 */
function shouldRetry(failureCount: number, error: Error): boolean {
  if (failureCount >= MAX_TENTATIVAS) {
    return false
  }

  if (ApiError.is(error) && error.isClientError) {
    return false
  }

  return true
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Dados de frota e reserva mudam por operação humana, não a cada
        // segundo: um minuto de frescor evita refetch em toda navegação.
        staleTime: MINUTO,
        gcTime: 5 * MINUTO,
        retry: shouldRetry,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 8000),
        refetchOnWindowFocus: false,
        // O erro é renderizado pelo estado de erro da tela, não jogado para o
        // ErrorBoundary — assim a navegação continua utilizável.
        throwOnError: false,
      },
      mutations: {
        // Mutação repetida sem Idempotency-Key duplica efeito. Quem precisar de
        // retry declara na própria mutação, junto com a chave.
        retry: false,
      },
    },
  })
}
